import React from "react";
import "./WashingServices.css";
import hero from "../images/washing ins.webp"
import before from "../images/wm dismental.jpg";
import after from "../images/washing-machine-repairing sccue.jpg"

function WashingServices() {

  return (
    <>




<section className="emergency-service-section">

  {/* Left Side */}

  <div className="emergency-left">

    <div className="emergency-badge">
      24/7 Emergency Support
    </div>

    <h1>
      Washing Machine <br />
      Suddenly Stopped <br />
      Working?
    </h1>

    <p>
      Chennai Washcare provides fast emergency washing machine
      repair service anywhere in Chennai with expert technicians
      and same day doorstep support.
    </p>

    {/* Features */}

    <div className="emergency-features">

      <div className="emergency-feature">
        ⚡ Quick Response
      </div>

      <div className="emergency-feature">
        🛠 Multi Brand Experts
      </div>

      <div className="emergency-feature">
        🚚 Doorstep Support
      </div>

    </div>

    {/* Button */}

    <a
      href="tel:+919790066906"
      className="emergency-btn"
    >
      Call Emergency Service
    </a>

  </div>

  {/* Right Side */}

  <div className="emergency-right">

    {/* Circle Design */}

    <div className="service-circle">

      <div className="circle-content">

        <h2>15+</h2>

        <p>
          Years Of Trusted <br />
          Service Experience
        </p>

      </div>

    </div>

    {/* Floating Cards */}

    <div className="emergency-floating-card card-1">
      Same Day Service
    </div>

    <div className="emergency-floating-card card-2">
      Genuine Spare Parts
    </div>

    <div className="emergency-floating-card card-3">
      Expert Technicians
    </div>

  </div>

</section>

    <section className="service-highlight-section">

  {/* Left Side */}

  <div className="service-highlight-image">

    <img
      src={hero}
      alt="washing-machine-service"
    />

    {/* Floating Box */}

    <div className="floating-highlight-box">

      <h2>15+</h2>

      <p>Years Experience</p>

    </div>

  </div>

  {/* Right Side */}

  <div className="service-highlight-content">

    <span>Why Choose Chennai Washcare</span>

    <h1>
      Professional Washing <br />
      Machine Repair Service
    </h1>

    <p>
      Chennai Washcare provides trusted multi brand washing machine
      repair services with expert technicians, genuine spare parts
      and fast doorstep support across Chennai.
    </p>

    {/* Features */}

    <div className="highlight-feature-list">

      <div className="highlight-feature-card">

        <h2>✔ Same Day Service</h2>

        <p>
          Quick technician visit and fast repair support.
        </p>

      </div>

      <div className="highlight-feature-card">

        <h2>✔ Genuine Spare Parts</h2>

        <p>
          High quality original spare parts with warranty.
        </p>

      </div>

      <div className="highlight-feature-card">

        <h2>✔ Expert Technicians</h2>

        <p>
          Skilled professionals for all washing machine brands.
        </p>

      </div>

    </div>

    {/* Button */}

  <a
  href="tel:+919790066906"
  className="highlight-btn"
>
  Book Service
</a>

  </div>

</section>

    <section className="washing-machine-types-section">

      {/* Heading */}

      <div className="washing-types-heading">

        <span>Our Expertise</span>

        <h1>
          We Service All Types Of <br />
          Washing Machines
        </h1>

        <p>
          Chennai Washcare provides professional repair and maintenance
          services for all washing machine models and brands across Chennai.
        </p>

      </div>

      {/* Cards */}

      <div className="washing-types-container">

        {/* Front Load */}

        <div className="washing-type-card">

          <div className="washing-icon">
            🌀
          </div>

          <h2>Front Load</h2>

          <p>
            Expert repair and maintenance service for all front load washing machines.
          </p>

        </div>

        {/* Top Load */}

        <div className="washing-type-card active-washing-card">

          <div className="washing-icon">
            💧
          </div>

          <h2>Top Load</h2>

          <p>
            Fast doorstep repair support for fully automatic top load machines.
          </p>

        </div>

        {/* Semi Automatic */}

        <div className="washing-type-card">

          <div className="washing-icon">
            ⚙️
          </div>

          <h2>Semi Automatic</h2>

          <p>
            Affordable repair and service support for semi automatic washing machines.
          </p>

        </div>

      </div>

    </section>


    <section className="before-after-section">

  {/* Heading */}

  <div className="before-after-heading">

    <span>Service Transformation</span>

    <h1>
      Before Service & <br />
      After Service Result
    </h1>

    <p>
      Chennai Washcare provides complete washing machine cleaning,
      maintenance and repair services for better performance.
    </p>

  </div>

  {/* Cards */}

  <div className="before-after-container">

    {/* Before Card */}

    <div className="before-card">

      <div className="before-tag">
        Before Service
      </div>

      <img
        src={before}
        alt="before-service"
      />

      <div className="before-content">

        <h2>Machine Problems</h2>

        <ul>

          <li>❌ Water Leakage</li>

          <li>❌ Drum Noise</li>

          <li>❌ Poor Washing Performance</li>

          <li>❌ Drainage Issue</li>

        </ul>

      </div>

    </div>

    {/* Arrow */}

    <div className="service-arrow">
      ➜
    </div>

    {/* After Card */}

    <div className="after-card">

      <div className="after-tag">
        After Service
      </div>

      <img
        src={after}
        alt="after-service"
      />

      <div className="after-content">

        <h2>Perfect Performance</h2>

        <ul>

          <li>✅ Smooth Washing</li>

          <li>✅ No Noise Issue</li>

          <li>✅ Fast Drying Support</li>

          <li>✅ Clean & Fresh Performance</li>

        </ul>

      </div>

    </div>

  </div>

</section>


<section className="service-area-section">

  {/* Heading */}

  <div className="service-area-heading">

    <span>Service Areas</span>

    <h1>
      Washing Machine Service <br />
      Available Across Chennai
    </h1>

    <p>
      Chennai Washcare provides fast doorstep washing machine repair
      services in all major areas across Chennai.
    </p>

  </div>

  {/* Area Cards */}

  <div className="service-area-container">

    <div className="service-area-card">
      <h2>T. Nagar</h2>
      <p>Fast Same Day Service</p>
    </div>

    <div className="service-area-card active-area-card">
      <h2>Velachery</h2>
      <p>Expert Technician Support</p>
    </div>

    <div className="service-area-card">
      <h2>Anna Nagar</h2>
      <p>Quick Doorstep Service</p>
    </div>

    <div className="service-area-card">
      <h2>Tambaram</h2>
      <p>Multi Brand Service</p>
    </div>

    <div className="service-area-card">
      <h2>Adyar</h2>
      <p>Affordable Repair Support</p>
    </div>

    <div className="service-area-card">
      <h2>Porur</h2>
      <p>Trusted Washing Machine Service</p>
    </div>

  </div>

</section>


<section className="floating-review-section">

  {/* Left Content */}

  <div className="floating-review-content">

    <span>Google Customer Rating</span>

    <h1>
      Chennai’s Trusted <br />
      Washing Machine <br />
      Service Experts
    </h1>

    <p>
      Thousands of customers trust Chennai Washcare for fast
      doorstep washing machine repair and professional support.
    </p>

    {/* Rating Row */}

    <div className="rating-row">

      <div className="big-rating-circle">

        <h2>4.9</h2>

        <div className="circle-stars">
          ★★★★★
        </div>

      </div>

      <div className="rating-details">

        <h3>2,500+ Happy Reviews</h3>

        <p>
          Rated highly for quick response, expert technicians and
          affordable service pricing.
        </p>

      </div>

    </div>

  </div>

  {/* Right Floating Reviews */}

  <div className="floating-review-cards">

    {/* Review 1 */}

    <div className="floating-card card-one">

      <div className="mini-review-stars">
        ★★★★★
      </div>

      <p>
        Technician arrived quickly and fixed my washing machine perfectly.
      </p>

      <h4>Arun Kumar</h4>

    </div>

    {/* Review 2 */}

    <div className="floating-card card-two">

      <div className="mini-review-stars">
        ★★★★★
      </div>

      <p>
        Best washing machine service center with genuine spare parts.
      </p>

      <h4>Priya Sharma</h4>

    </div>

    {/* Review 3 */}

    <div className="floating-card card-three">

      <div className="mini-review-stars">
        ★★★★★
      </div>

      <p>
        Same day doorstep repair support and affordable pricing.
      </p>

      <h4>Vignesh R</h4>

    </div>

  </div>

</section>



<section className="wm-faq-section">

  {/* Heading */}

  <div className="wm-faq-heading">

    <span>Washing Machine FAQ</span>

    <h1>
      Frequently Asked <br />
      Questions
    </h1>

    <p>
      Common questions customers ask about washing machine
      repair and maintenance services in Chennai.
    </p>

  </div>

  {/* FAQ Container */}

  <div className="wm-faq-container">

    {/* FAQ 1 */}

    <div className="wm-faq-card">

      <div className="faq-number">
        01
      </div>

      <div className="faq-content">

        <h2>
          Why is my washing machine making loud noise while spinning?
        </h2>

        <p>
          Loud noise may happen because of drum issues, damaged bearings,
          loose parts or overload problems. Our technicians will inspect
          and fix the issue quickly.
        </p>

      </div>

    </div>

    {/* FAQ 2 */}

    <div className="wm-faq-card active-faq-card">

      <div className="faq-number">
        02
      </div>

      <div className="faq-content">

        <h2>
          Why is water not draining from my washing machine?
        </h2>

        <p>
          Drain blockage, pump failure or pipe issues can stop water
          drainage. Chennai Washcare provides fast doorstep repair support.
        </p>

      </div>

    </div>

    {/* FAQ 3 */}

    <div className="wm-faq-card">

      <div className="faq-number">
        03
      </div>

      <div className="faq-content">

        <h2>
          How often should I service my washing machine?
        </h2>

        <p>
          Regular maintenance every 6 to 12 months helps improve washing
          performance and increases machine life.
        </p>

      </div>

    </div>

    {/* FAQ 4 */}

    <div className="wm-faq-card">

      <div className="faq-number">
        04
      </div>

      <div className="faq-content">

        <h2>
          Do you provide service for all washing machine brands?
        </h2>

        <p>
          Yes, we repair LG, Samsung, IFB, Bosch, Whirlpool, Panasonic
          and all major washing machine brands.
        </p>

      </div>

    </div>

  </div>

</section>

<section className="washing-benefits-section">

  {/* Left Side */}

  <div className="washing-benefits-left">

    <span>Benefits Of Regular Service</span>

    <h1>
      Keep Your Washing <br />
      Machine Running <br />
      Like New
    </h1>

    <p>
      Regular washing machine maintenance improves performance,
      reduces breakdowns and increases machine lifespan.
    </p>

    {/* Benefits */}

    <div className="benefits-list">

      <div className="benefit-item">
        <div className="benefit-dot"></div>
        Better Washing Performance
      </div>

      <div className="benefit-item">
        <div className="benefit-dot"></div>
        Prevents Water Leakage Issues
      </div>

      <div className="benefit-item">
        <div className="benefit-dot"></div>
        Increases Machine Life
      </div>

      <div className="benefit-item">
        <div className="benefit-dot"></div>
        Reduces Power Consumption
      </div>

    </div>

  </div>

  {/* Right Side */}

  <div className="washing-benefits-right">

    <div className="benefits-main-card">

      <h2>98%</h2>

      <p>
        Customer Satisfaction
      </p>

    </div>

    <div className="mini-benefit-card top-card">

      <h3>15+</h3>

      <span>Years Experience</span>

    </div>

    <div className="mini-benefit-card bottom-card">

      <h3>12K+</h3>

      <span>Machines Repaired</span>

    </div>

  </div>

</section>








    </>

  );

}

export default WashingServices;